module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-21-1e4dfb667c9aceb5400394a2e0cd85dd.png";